import React from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Sidebar from '../Sidebar';
import NavBar from '../NavBar';
import BreadcrumbsBar from './Breadcrumbs';
import EnvironmentBanner from './EnvironmentBanner';
import { LayoutUIProvider } from './LayoutUIContext';

const Page = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
`;

const Shell = styled.div`
    display: flex;
    min-height: 100vh;
    background: rgb(247, 249, 252);
`;

const RightPane = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-width: 0;
    background: rgb(247, 249, 252);
`;

const Topbar = styled.div`
  position: sticky;
  top: 0;
  z-index: 1000;
  border-bottom: 1px solid #e5e7eb;
  line-height: normal;
  background: #fff;
`;

/* Scrollable content area beneath the topbar */
const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  box-sizing: border-box;
  padding: clamp(16px, 3vw, 24px) clamp(20px, 4vw, 28px);
  @media (max-width: 600px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const Main = styled.main`
  max-width: 1440px;
  width: 100%;
  flex: 1 1 auto;
  min-width: 0;
  background: rgb(245, 247, 250);
  margin: 0 auto;
`;

const MinimalWrap = styled.div`
  flex: 1 1 auto;
  background: rgb(247, 249, 252);
  box-sizing: border-box;
  padding: clamp(16px, 3vw, 24px) clamp(20px, 4vw, 28px);
  display: block;
`;

const MinimalMain = styled.main`
    max-width: 1440px;
    width: 100%;
    margin: 0 auto;
`;

const PUBLIC_ROUTE_RE = /^\/(login|register|email-verify|forgotten-password|reset-password|pricing|checkout)(\/|$)/i;

export default function AppLayout({ children }) {
    const { pathname } = useLocation();
    const loggedIn = useSelector((s) => Boolean(s?.login?.userDetails?.isLoggedIn));

    const useMinimal = !loggedIn || PUBLIC_ROUTE_RE.test(pathname);

    if (useMinimal) {
        return (
            <LayoutUIProvider>
                <Page>
                    <EnvironmentBanner />
                    <MinimalWrap>
                        <MinimalMain role="main">{children}</MinimalMain>
                    </MinimalWrap>
                </Page>
            </LayoutUIProvider>
        );
    }

    return (
        <LayoutUIProvider>
            <Shell>
                <Sidebar />
                <RightPane>
                    <EnvironmentBanner />
                    <Topbar role="banner">
                        <NavBar />
                    </Topbar>
                    <Content>
                        <BreadcrumbsBar />
                        <Main role="main">{children}</Main>
                    </Content>
                </RightPane>
            </Shell>
        </LayoutUIProvider>
    );
}
